var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1H13.4349L12.3683 11.6462C12.324 11.9397 12.1755 12.2072 11.9502 12.3994C11.7249 12.5917 11.4379 12.6957 11.1423 12.6924H3.41831C3.15095 12.7064 2.88638 12.6321 2.665 12.481C2.44361 12.3299 2.27759 12.1102 2.19228 11.8554L0.561668 6.93234C0.500871 6.74725 0.484729 6.55031 0.51457 6.35773C0.544411 6.16515 0.619381 5.98244 0.733311 5.82464C0.852001 5.65686 1.0107 5.52163 1.1949 5.43132C1.3791 5.34102 1.58291 5.29852 1.78769 5.30771H13.0058",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62668 16.9999C3.96524 16.9999 4.2397 16.7244 4.2397 16.3846C4.2397 16.0447 3.96524 15.7692 3.62668 15.7692C3.28813 15.7692 3.01367 16.0447 3.01367 16.3846C3.01367 16.7244 3.28813 16.9999 3.62668 16.9999Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5964 16.9999C11.935 16.9999 12.2094 16.7244 12.2094 16.3846C12.2094 16.0447 11.935 15.7692 11.5964 15.7692C11.2579 15.7692 10.9834 16.0447 10.9834 16.3846C10.9834 16.7244 11.2579 16.9999 11.5964 16.9999Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.f03fcc9cf08669a256f3156956e47a12.svg";
export { ForwardRef as ReactComponent };